import React from 'react';
import { useParams } from 'react-router-dom';
import HeaderComponent from '../components/General/HeaderComponent';
import MenuBarComponent from '../components/Panel/MenuBarComponent';
import RemindersComponent from '../components/Panel/RemindersComponent';

const Reminders = () => {
  const { id } = useParams(); // projectId
  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title="Hatırlatıcı" />
        <MenuBarComponent title="reminders" />
        <div className="mt-2 bg-white dark:bg-dark-200 rounded-xl shadow-sm border border-gray-200 dark:border-dark-300 mb-6 h-[calc(100vh-200px)] overflow-hidden">
          <RemindersComponent projectId={id} />
        </div>
      </div>
    </div>
  );
};

export default Reminders;
